module.exports = __webpack_public_path__ + "img/69.6.CODm.e6660cbd.png";